// extracted by css-extract-rspack-plugin
export default {"form":"ShlLx6DewwaZXe1n","field":"eUWhXNF9mho3U4u0","fieldHeader":"lS8MtrZiwZ0mV0nP","actions":"b0FogBnEtTA6wVCR"};